import {Link} from 'gojs';

export const highlightConnections = (link: Link) => {
  // highlight all Links and Nodes coming out of a given Node
  const diagram = link.diagram;
  if (diagram) {
    diagram.startTransaction('highlight-link');
    // remove any previous highlighting
    diagram.clearHighlighteds();
    // for each Link coming out of the Node, set Link.isHighlighted

    if (link.fromNode) {
      link.fromNode.isHighlighted = true;
    }
    if (link.toNode) {
      link.toNode.isHighlighted = true;
    }

    diagram.commitTransaction('highlight-link');
  }
};
